export const API_URL = 'https://pokeapi.co/api/v2/pokemon'
export const LIMIT = 16;